var app = angular.module('leonardo');

var DynamicFormDocumentSelector = function($http, ngDialog, AuthDataService, FilterService, FolderFileService,
                                           DynamicFormRestService, FolderService, PropertyService,
                                           NotificationService, AccountUserService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/dynamic-form-document-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      account: '=?',
      clientInstance: '=?'
    },
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.ngModelCtrl.$render = function () {
        if (scope.ngModelCtrl.$modelValue) {
          DynamicFormRestService.get(scope.ngModelCtrl.$modelValue).then(function (data) {
            scope.dynamic_form = data;
            scope.file = {name: data.name};
          });
        }
      };


      scope.getSector = function () {
        if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
          return FilterService.hasFilter('sector') ? FilterService.getFilter('sector') : null;
        }
        return null;
      };

      scope.removeFile = function () {
        scope.file = null;
        scope.ngModelCtrl.$setViewValue(null);
      };

      scope.openDynamicFormDialog = function (dynamic_form) {
        if (dynamic_form) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/task/dynamic-form-react.html',
            className: 'ngdialog-theme-default ngdialog-dynamic-form',
            controller: 'TaskDynamicFormDialogReact',
            resolve: {
              formObj: [function () {
                return dynamic_form.id ? DynamicFormRestService.get(dynamic_form.id) : DynamicFormRestService.get(dynamic_form);
              }],
              formDataObj: [function () {
                return null;
              }]
            },
            data: {
              task: {},
              approvalStatus: false,
              property: FilterService.currentProperty,
              mode:'read'
            }
          }).then(function (result) {
            callback(result);
          });
        }
      };

      scope.showDocManager = function() {
        FolderService.getlist({
          purpose: FolderService.PURPOSE_DYNAMIC_FORMS,
          account: scope.account ? scope.account : AccountUserService.currentAccountUser.account
        }).then(function(data){
          var folder = null;
          var allfolder = null;
          if (data.length > 0) {
            folder = data[0];
            allfolder = data;
          }
          ngDialog.openConfirm({
            template: 'views/templates/dialog/folder/selector.html',
            controller: 'FolderSelectorDialog',
            data: {
              rootFolder: folder,
              sector: scope.getSector(),
              disable_folder: true,
              mode_folder: 'files',
              action: 'select',
              only_dynamic: true,
              folder: folder,
              account: scope.account,
              excludeFolder: folder ? folder.id : folder,
              allfolder: allfolder,
              client_instance: scope.clientInstance
            }
          }).then(function (file) {
            if (file) {
              scope.file = {name: file.destiny.name};
              scope.dynamic_form = file.destiny.id;
              scope.ngModelCtrl.$setViewValue(scope.dynamic_form);
            }
          });
        });
      };
    }
  };
};

app.directive('dynamicFormDocumentSelector', ['$http', 'ngDialog', 'AuthDataService', 'FilterService',
  'FolderFileService', 'DynamicFormRestService', 'FolderService', 'PropertyService', 'NotificationService',
  'AccountUserService', DynamicFormDocumentSelector]);
